import {
  Fragment,
  type FC
} from 'react';
import {
  Box,
  Stack,
  Typography
} from '@mui/joy';
import {
  addThousandSeparators
} from '@shared/lib';
import {
  key,
  safe,
  keyBG,
} from '../assets';
import {
  ChallengeStatusEnum
} from '../model';

export type ChallengeProgressInfoProps = {
  progress: number;
  textColor: string;
  percentage: number;
  challengeTarget: number;
  status: ChallengeStatusEnum;
};

export const ChallengeProgressInfo: FC<ChallengeProgressInfoProps> = ({
  status,
  progress,
  textColor,
  percentage,
  challengeTarget,
}) => {
  const challengeProgressPoints = Math.min(challengeTarget, parseInt(progress.toFixed(0)));
  return (
    <Stack>
      <Box
        position='relative'
        sx={({ palette }) => ({
          height: 8,
          borderWidth: 1,
          borderStyle: 'solid',
          borderRadius: 100,
          borderColor: palette.common[1100],
          backgroundColor: palette.common.white,
        })}>
        <Box
          display='block'
          sx={({ palette }) => ({
            height: 8,
            borderRadius: 100,
            position: 'relative',
            width: `${percentage}%`,
            background: `linear-gradient(90deg, ${palette.common[1150]} 0%, ${palette.common.error} 100%)`,
          })}>
          {((percentage < 100 && status === ChallengeStatusEnum.Active)) && (
            <Fragment>
              <Box
                component='img'
                src={key.default}
                sx={{
                  top: 0,
                  right: 0,
                  width: 35,
                  zIndex: 2,
                  position: 'absolute',
                  transform: 'translate(50%, -50%)'
                }}
              />
              <Box
                component='img'
                src={keyBG.default}
                sx={{
                  top: 0,
                  right: 0,
                  width: 250,
                  position: 'absolute',
                  transform: 'translate(45%, -50%)'
                }}
              />
            </Fragment>
          )}
        </Box>
        <Box
          component='img'
          src={safe.default}
          sx={{
            top: 0,
            right: 0,
            zIndex: 2,
            width: 50,
            position: 'absolute',
            transform: 'translate(85%, -50%)'
          }} />
      </Box>
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 600,
          color: textColor,
          textAlign: 'center',
        }}>
        {`${addThousandSeparators(challengeProgressPoints)}/${addThousandSeparators(challengeTarget)}`}
      </Typography>
    </Stack>
  );
};